import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

//Services
import { UtilityService } from '../../../core/services/utility.service';
import { PortalSettingsService } from '../../../core/services/portal-settings.service';
import { SignalRService } from './../../../core/services/signal-r.service';
import { HiringService } from './../../../pages/hiring/services/hiring.service';

@Component({
  selector: 'app-onboard-submitted-modal',
  templateUrl: './onboard-submitted-modal.component.html',
  styleUrls: ['./onboard-submitted-modal.component.css']
})
export class OnboardSubmittedModalComponent implements OnInit {
  @Input() loginStatus: any;
  @Input() info: any;
  @Input() reqID: any;
  @Input() status: any;
  portalSettings: any;
  jobTargetTrackingURL: any;
  alert: any;
  openModalLeft: any;

  constructor(portalSettingsService: PortalSettingsService, private utilityService: UtilityService, private signalRService: SignalRService, private hiringService: HiringService, public activeModal: NgbActiveModal) {
    this.portalSettings = portalSettingsService.getPortalSettings();
    this.signalRService.establishHub('progressHub', 'downloadComplete');
  }

  ngOnInit(): void {
    //SignalR connection
    this.signalRService.downloadCompletedEvent.subscribe((filename: any) => {
      setTimeout(() => {
        this.utilityService.closeModal();
      }, 1000);
    });
    this.jobTargetTrackingURL = this.portalSettings.JobTargetTrackingURL.ConfigValue;
    this.openModalLeft = (window.innerWidth - 200) / 2;
    if (this.status) {
      this.alert = ({ type: "success", msg: "Your tasks are complete - no further action is required." });
    }
    else {
      this.alert = ({ type: "danger", msg: "Your tasks were not submitted successfully.  Please try again or contact your administrator." });
    }
  }

  closeClicked() {
    if (!this.info.IsOnboarding)
      window.location.href = "/Careers/BrowseJobs";
    else
      window.location.href = "/Careers/Welcome";
  }

  returnClicked() {
    window.location.href = "/Hiring/JobReqDetail/#" + (this.reqID != null ? this.reqID : this.info.ReqID) + "/JR/stage=/search=";
  }

  downloadRDL() {
    this.openModal();
  }

  openModal() {
    document.getElementById('modal').style.display = 'block';
    document.getElementById('modal').style.left = this.openModalLeft + 'px';
    document.getElementById('fade').style.display = 'block';
  }
}